import NBType, { InferType } from '@netbase/nb-type'
import MeasurementType from '../enums/MeasurementType'

const MeasurementFilterSchema = NBType.object().shape('MeasurementFilterSchema', {
  /* @prop */
  names: NBType.array().of(NBType.string()).nullable(),
  /* @prop */
  overallChecked: NBType.boolean(),
  /* @prop */
  type: NBType.enum(MeasurementType),
  /* @prop */
  values: NBType.array().of(NBType.number())
  /* END */
})
export default MeasurementFilterSchema
export type MeasurementFilter = InferType<typeof MeasurementFilterSchema>
// RESERVE BELOW
